import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {EntityName} from '../types';

import {ChangelogHeader} from './changelog-header';
import {ChangelogTable} from './changelog-table';
import {ChangelogUpsell} from './changelog-upsell';
import {useGetChangelog} from './use-get-changelog';

import styles from './changelog.module.css';

type Props = {
    entityId: string;
    entityName: EntityName;
    entityPageName: string;
};

export function Changelog(props: Props) {
    const {entries, totalCount, isLoading, error} = useGetChangelog(props.entityId);

    return (
        <div className={styles.container}>
            <StackLegacy spacing={16}>
                <ChangelogHeader
                    entityPageName={props.entityPageName}
                    entityName={props.entityName}
                    changeCount={totalCount}
                    isLoading={isLoading}
                />
                {NutClientConfig.hasEntityPageChangelog ? (
                    <ChangelogTable
                        entries={entries}
                        // @ts-expect-error
                        totalCount={totalCount}
                        isLoading={isLoading}
                        error={error}
                    />
                ) : (
                    <ChangelogUpsell />
                )}
            </StackLegacy>
        </div>
    );
}
